<div [formGroup]="accountForm" class="form-container">
    <aum-input
        [aumFormControl]="accountNumber"
        floatLabel="auto"
        id="accountNumber"
        [simpleInput]="true"
        [placeholder]="localizationKeys.aumico_editable_account_placeholder_number | i18next"
        [disabled]="
            account.type === AccountType.UNCOVERED_SHORTFALL ||
            account.isBalanceSwitchAccount ||
            account.isMasterCloneAccount
        "
    >
    </aum-input>

    <aum-input
        [aumFormControl]="name"
        floatLabel="auto"
        id="name"
        [simpleInput]="true"
        [placeholder]="localizationKeys.aumico_editable_account_placeholder_name | i18next"
        [disabled]="account.isBalanceSwitchAccount"
    >
    </aum-input>
    <aumico-number-input
        class="number-input"
        [control]="calculatedClosingBalance"
        [placeholder]="localizationKeys.aumico_editable_account_placeholder_closing_value | i18next"
        [disabled]="account.type === AccountType.UNCOVERED_SHORTFALL"
    >
    </aumico-number-input>
    <aumico-number-input
        *ngIf="hasPreviousData"
        class="number-input"
        [control]="calculatedOpeningBalance"
        [placeholder]="localizationKeys.aumico_editable_account_placeholder_opening_value | i18next"
        [disabled]="account.type === AccountType.UNCOVERED_SHORTFALL"
    >
    </aumico-number-input>
    <div class="form-container__actions">
        <mat-icon class="form-container__actions--save" svgIcon="save" (click)="onSaveAccount()"></mat-icon>

        <mat-icon class="form-container__actions--noaction" svgIcon="close" (click)="onCancel()"></mat-icon>
    </div>
</div>

<mat-error *ngIf="accountNumber.hasError('accountNumberExist')">{{
    localizationKeys.aumico_editable_account_number_unique_validator | i18next
}}</mat-error>
